import { walk } from 'react-sortable-tree'
import { getNodeKey } from '../../components/list/window1/functions'
import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export default async function importTreeNodes (node, rootNodeInfo, breakMedia) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  const collectionReference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('TreeNodes')

  const isRootNode = (target) => (node.id === target.id)

  savingStart()
  walk({
    treeData: [node],
    ignoreCollapsed: false,
    getNodeKey,
    callback: async ({ node, parentNode, path, lowerSiblingCounts, treeIndex }) => {
      const data = {
        title: node.title || '',
        subtitle: node.subtitle || '',
        expanded: node.expanded || false,
        parentId: isRootNode(node) ? rootNodeInfo.parentId : (parentNode ? parentNode.id : new Error()),
        orderAsChild: isRootNode(node) ? rootNodeInfo.orderAsChild : node.editableValues.orderAsChild,
        difficulty: node.editableValues.difficulty,
        update: node.editableValues.update,
        interval: node.editableValues.interval,
        ratingRecord: node.editableValues.ratingRecord,
        failStatus: node.editableValues.failStatus || 'solved'
      }
      if (node.isSpreadsheet && !breakMedia) {
        data.isSpreadsheet = true
        data.spreadsheetId = node.spreadsheetId
      } else if (node.isUploadType2 && !breakMedia) {
        data.isUploadType2 = true
        data.uploadType2Id = node.uploadType2Id
      }
      try {
        await collectionReference.doc(node.id).set(data)
      } catch (e) {
        handleErrorInCatch(e, 'importData.js')
      }
    }
  })
  savingEnd()
}
